import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import UserScapes from "./UserScapes";
import LegacyScapeListView from "./LegacyScape/LegacyScapeListView";
import GameView from "./GameView";
import ScapeView from "./LegacyScape/ScapeView";
import ScapeList from "./ScapeList";

const getRouter = (
    basename: string,
    msalInstance: PublicClientApplication,
) => {
    return createBrowserRouter([
        {
            path: "/",
            element: <App msalInstance={msalInstance} />,
            children: [,
                {
                    index: true,
                    element: <ScapeList />
                },
                {
                    path: "Scape/:scapeId",
                    element: <ScapeView />
                },
                {
                    path: "Game/:gameId",
                    element: <GameView />
                },
            ]
        }],
        { basename: basename }
    );
}

export default getRouter;